import EventCollageSizeSuccessModal from './EventCollageSuccessModal';

export default EventCollageSizeSuccessModal;
